import React, { useRef } from "react";
import { FileUpload } from 'primereact/fileupload';
import fetchMethodRequest from '../../../config/service';
import showToasterMessage from '../../../containers/UI/ToasterMessage/toasterMessage';
import config from '../../../config/config';
import configImages from '../../../config/configImages';
import { Link } from 'react-router-dom';

const DoFileUpload = (props) => {
    const fileInputRef = useRef(null);

    const id = props.id ? props.id : props.name;
    let label = props.label ? props.label : '';
    let newFiles = (props.field.value) ? [props.field.value] : ''
    let isMultiple = props.isMultiple ? props.isMultiple : false;
    let modeType = props?.modeType ? props.modeType : 'advanced'
    let type = props.type;
    let maxFileSize = 2 * 1024 * 1024;

    // let maxFileSize = props.maxFileSize

    const onSelect = (e) => {
        const selectedFiles = isMultiple ? e.files : [e.files[0]];
        maxFileSize = 20 * 1024 * 1024; // 2MB
        console.log("selectedFiles", selectedFiles)
        if (type == "Recordings") {
            maxFileSize = 10 * 1024 * 1024; // 10MB
            console.log("maxFileSize", maxFileSize)
        }

        // Separate valid and oversized files
        const validFiles = selectedFiles.filter(file => file.size <= maxFileSize);
        const oversizedFiles = selectedFiles.filter(file => file.size > maxFileSize);

        // Show error if any oversized files exist
        if (oversizedFiles.length > 0) {
            showToasterMessage("Files exceed 2MB and were removed.", "error");

            // Remove oversized files from PrimeReact preview
            if (fileInputRef.current) {
                fileInputRef.current.setFiles(validFiles);
            }
        }

        // If no valid files remain, clear upload and stop
        if (validFiles.length === 0) {
            clearFileUpload();
            return;
        }

        // Upload valid files
        const toUpload = isMultiple ? validFiles : validFiles[0];
        uploadFilesToServer(toUpload);
    };
    // Get file icon based on file extension
    const getFileIcon = (fileName) => {
        if (!fileName) return 'pi pi-file text-muted';

        const ext = fileName.split('.').pop().toLowerCase();

        switch (ext) {
            case 'pdf':
                return 'pi pi-file-pdf text-danger';
            case 'docx':
            case 'doc':
                return 'pi pi-file-word text-primary';
            case 'txt':
                return 'pi pi-file text-secondary';
            case 'xlsx':
            case 'xls':
                return 'pi pi-file-excel text-success';
            case 'pptx':
            case 'ppt':
                return 'pi pi-file-powerpoint text-warning';
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                return 'pi pi-image text-info';
            default:
                return 'pi pi-file text-muted';
        }
    }

    // Truncate file names
    const truncateFileName = (fileName, maxLength = 20) => {
        if (!fileName) return 'File';
        if (fileName.length <= maxLength) return fileName;
        const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
        const ext = fileName.split('.').pop();
        if (nameWithoutExt.length <= maxLength - 3) return fileName;
        return nameWithoutExt.substring(0, maxLength - 3) + '...' + ext;
    }
    const upload = (e) => {
        uploadFilesToServer(isMultiple ? e.files : e.files[0]);
    }

    const setProgressBarResponse = (initialFiles, status) => {
        if (props.updateFileStatus) {
            initialFiles.forEach((file, index) => props.updateFileStatus(index, 100, status));
        }
    }

    const uploadFilesToServer = (data) => {
        const initialFiles = data && data.map ? data.map(file => ({
            name: file.name,
            progress: 0,
            status: 'uploading'
        })) : [];
        if (props.showCurrentFilesInProgressBar) {
            props.showCurrentFilesInProgressBar(true)
            if (props.setFilesToProgressBar) {
                props.setFilesToProgressBar(initialFiles)
            }
            if (props.updateFileProgress) {
                props.updateFileProgress({ totalFiles: initialFiles.length, uploadedFiles: 0 })
            }
        }
        if (modeType === 'basic') {
            clearFileUpload()
        }
        if (props.customFunction && props?.parameters?.beforeUpload) {
            props.customFunction(props?.parameters?.beforeUpload)
        }

        fetchMethodRequest('POST', props.url, data, 'upload', isMultiple, props?.assingValueToForm)
            .then(async (response) => {
                if (props.type === 'profile') {
                    if (localStorage.getItem('loginCredentials')) {
                        let data = JSON.parse(localStorage.getItem('loginCredentials'))
                        if (data) {
                            data.photo = response.fileName;
                            localStorage.setItem('loginCredentials', JSON.stringify(data))
                            if (props.setAvatarUrl) {
                                console.log(data)
                                props.setAvatarUrl(config.profileUrl + data.photo)
                            }
                        }
                    }
                    props.field.onChange(response.fileName)
                    clearFileUpload();
                    newFiles = [response.fileName]
                }
                if (props.type === 'comparefiles') {
                    props.field.onChange(response.fileName);
                    if (props.onSuccess) {
                        props.onSuccess({ [props.field.name]: response });
                    }
                    clearFileUpload();
                }
                if (props?.onSuccess && props.type !== 'comparefiles') {
                    props.onSuccess(response);
                    if (props.customFunction && props?.parameters) {
                        props.customFunction(props?.parameters?.afterUpload)
                    }
                }
                if (response && response.respMessage) {
                    if (props.type === "Files" || props.type === "Folders" && response?.fileExists) {
                        const payload = { method: 'POST', url: props.url, data: data, type: 'upload', isMultiple: isMultiple, assignValueToForm: props.assingValueToForm };
                        props.getDocumentConfirmation(payload);
                        setProgressBarResponse(initialFiles, 'fail');

                    } else {
                        props.closeFormModal();
                        showToasterMessage(response.respMessage, 'success');
                        setProgressBarResponse(initialFiles, 'success');
                    }

                } else if (response && response.errorMessage) {
                    showToasterMessage(response.errorMessage, 'error');
                    setProgressBarResponse(initialFiles, 'error');
                } else {
                    showToasterMessage('upload failed')
                    setProgressBarResponse(initialFiles, 'error');
                }
            }).catch((err) => {
                setProgressBarResponse(initialFiles, 'error');
                return err;
            });
    }

    const checkImg = (img) => {
        if (img) {
            return config.imageFormats.some(x => img.toLowerCase().includes(x));
        }
        return false;
    };

    const deleteFile = (img) => {
        if (props.setAvatarUrl) {
            props.setAvatarUrl(null)
        }
        if (img) {
            let allFiles = newFiles.filter(file => file !== img)
            if (allFiles && allFiles.length === 0) {
                props.field.onChange('')
            } else {
                props.field.onChange(allFiles)

            }
        }
    };

    const clearFileUpload = () => {
        if (fileInputRef.current) {
            fileInputRef.current.clear()
        }
    };


    return (
        <div className={`d-flex ${type === 'comparefiles' ? 'justify-content-start align-items-center gap-3 flex-wrap' : 'flex-column'}`}>
            {!props.hideLabel &&
                <div className="flex align-center">
                    <label htmlFor={id} className="text-capitalize">{label}</label>
                </div>
            }
            <FileUpload
                ref={fileInputRef}
                mode={modeType}
                name={props.name ? props.name : 'file'}
                // accept={props.acceptType ? props.acceptType : '*'}
                auto={props.autoSubmit}
                accept={props.acceptType ? props.acceptType : '.pdf,.docx'}
                onSelect={!isMultiple ? onSelect : ''}
                emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>}
                customUpload
                uploadHandler={onSelect}
                multiple={isMultiple ? isMultiple : false}
                chooseLabel={props.label ? props.label : 'Choose File'}
                chooseOptions={props?.chooseOptions ? props?.chooseOptions : { className: '' }}
            />
            <div>
                {newFiles && newFiles.length > 0 && (
                    <div className="d-flex flex-wrap">
                        {newFiles.map(img => (
                            <div className="row w-50" >
                                <div className="col-7 my-2">
                                    {props.type === 'profile' ? (
                                        (<Link to={`${config.profileUrl}${img}`} target="_blank">
                                            <img src={config.profileUrl + img} style={{ width: '100%', height: '100%' }} alt="" />
                                        </Link>)
                                    ) : props.type === 'comparefiles' ? (
                                        <div className="icon-container file-icon">
                                            <Link to={`${config.compareFilesURL}${img}`} target="_blank" className="icon-link">
                                                <div className="icon-wrapper file">
                                                    <i className={getFileIcon(img)}></i>
                                                    <div className="icon-overlay">
                                                        <i className="pi pi-external-link"></i>
                                                    </div>
                                                </div>
                                                <div className="icon-label truncate-text" title={img}>
                                                    {truncateFileName(img, 15)}
                                                </div>
                                            </Link>
                                        </div>
                                    ) : checkImg(img) ? (
                                        <div className="icon-container image-icon">
                                            <Link to={`${config.imgUrl}${type.toLowerCase()}/${img}`} target="_blank" className="icon-link">
                                                <div className="icon-wrapper image">
                                                    <i className="pi pi-image text-success"></i>
                                                    <div className="icon-overlay">
                                                        <i className="pi pi-search-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="icon-label">View Image</div>
                                            </Link>
                                        </div>
                                    ) : (
                                        <div className="icon-container document-icon">
                                            <a href={`${config.imgUrl}${type.toLowerCase()}/${img}`} target='_blank' className="icon-link">
                                                <div className="icon-wrapper document">
                                                    <i className={getFileIcon(img)}></i>
                                                </div>
                                                <div className="icon-label truncate-text" title={img}>
                                                    {truncateFileName(img, 15)}
                                                </div>
                                                <div className="download-badge">
                                                    <i className="pi pi-download"></i>
                                                </div>
                                            </a>
                                        </div>
                                    )}
                                </div>
                                <div className="col-4 my-3">
                                    <button className="btn text-danger" type='button' onClick={() => deleteFile(img)} style={{ padding: '5px 10px' }}>
                                        <i className="pi pi-trash" />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
export default DoFileUpload;